<script>
  import { timeSoftMethods } from '@state/helpers'
  import { required, maxLength, helpers, minLength, minValue, alphaNum } from 'vuelidate/lib/validators'
  import DatePicker from 'v-calendar/lib/components/date-picker.umd'
  import ConfirmModal from '@components/ConfirmModal.vue'
  
  
  // import EuroCouponsItemForm from '@components/euro_coupons/item/Form'
  import XLSX from 'xlsx'
  
  const minRequired = (value) => value.length > 0 && value.length <= 1300
  const someError = (items) => !items.some((item) => item.error === true)
  const mustBeOption = (value) => ['1'].includes(value)

  const dateRangeFormat = (value) => {
    value = value.replace(/\s/g, '').replace('–','-')
    const dateFormatRegex = /^\d{2}:\d{2}-\d{2}:\d{2}$/;
    const dateFormatRegex1 = /^\d{1}:\d{2}-\d{2}:\d{2}$/;
    const dateFormatRegex2 = /^\d{1}:\d{2}-\d{1}:\d{2}$/;
    const dateFormatRegex3 = /^\d{2}:\d{2}-\d{1}:\d{2}$/;
    const dateFormatRegex4 = /^\d{2}:\d{2}$/;
    const dateFormatRegex5 = /^\d{1}:\d{2}$/;
    const textFormat = /^[a-zA-Z0-9\s*]+$/;
    if(dateFormatRegex.test(value)) return true
    if(dateFormatRegex1.test(value)) return true
    if(dateFormatRegex2.test(value)) return true
    if(dateFormatRegex3.test(value)) return true
    if(dateFormatRegex4.test(value)) return true
    if(dateFormatRegex5.test(value)) return true
    if(textFormat.test(value)) return true
    return false
  };
  
  export default {
    name: 'UploadData',
    components: { DatePicker, ConfirmModal },
    props: {
      fullform: {
        type: Boolean,
        required: false,
        default: false,
      },
      instanceJson: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      oncomplete: {
        type: Function,
        required: false,
        default: () => ({}),
      },
      oncancel: {
        type: Function,
        required: false,
        default: () => ({}),
      },
      type_action:{
        type: String,
        default: 'create'
      }
    },
    data() {
      return {
        date_start:null,
        date_end:null,
        modalShow: true,
        loading: true,
        submitting: false,
        showConfirmModal: false,
        reading: false,
        action: 'create',
        selectedFile: false,
        file: null,
        form: {
          rows: [
          ],
          date_start:null,
          date_end:null
        },
        quantity: null,
        value: null,
  
        //Table
        fields: [
          {
            key: 'document',
            label: this.$t('document'),
          },
          {
            key: 'lunes',
            label: 'Lunes',
          },
          {
            key: 'martes',
            label: 'Martes',
          },
          {
            key: 'miercoles',
            label: 'Miercoles',
          },
          {
            key: 'jueves',
            label: 'Jueves',
          },
          {
            key: 'viernes',
            label: 'Viernes',
          },
          {
            key: 'sabado',
            label: 'Sabado',
          },
          {
            key: 'domingo',
            label: 'Domingo',
          },
          {
            key: 'actions',
            label: this.$t(''),
          },
        ],
        items: [],
        modelConfig: {
        },
      }
    },
    validations: {
      form: {},
      items: {
        minRequired,
        someError,
        $each: {
          document: {
            required,
            minLength: minLength(4),
            maxLength: maxLength(11)
          },
          schedule: {
            d1:{
              dateRangeFormat
            },
            d2:{
              dateRangeFormat
            },
            d3:{
              dateRangeFormat
            },
            d4:{
              dateRangeFormat
            },
            d5:{
              dateRangeFormat
            },
            d6:{
              dateRangeFormat
            },
            d7:{
              dateRangeFormat
            },
          }
        }
      }
    },
    computed: {},
  
    watch: {
      items: {
        deep: true,
        handler(values) {
          values = values.map((item, index) => {
            item['document'] = Number(item['document']
            )
            return item
          })
  
          this.form.rows = values
          this.quantity = values.length
          this.value = values.reduce((a, b) => a + b['value'], 0)
        },
      },
    },
  
    mounted: function () {
      let context = this
      context.form = {
        ...context.form,
        ...context.instanceJson,
      }
      // if (context.instanceJson.url) {
      //   context.action = 'update'
      //   // context.getObject()
      // } else {
        context.action = 'create'
        context.loading = false
      // }
    },
  
    methods: {
      ...timeSoftMethods,
  
  
      tbodyRowClass(item) {
        return item.error === true ? ['table-danger'] : ''
      },
      removeItem(index) {
        this.items.splice(index, 1)
        // this.$v.items.$touch()
      },
      toggleError(index) {
        this.items[index].error = !this.items[index].error
        // this.$v.items.$touch()
      },
      dateFormat(value) {
        return value.toISOString().split('T')[0]
      },
  
      exportExcel() {
        const sheetToExport = [
          {
            'CEDULA': null, //A
            'LUNES DD-MM-AAAA': null, // B
            'MARTES DD-MM-AAAA': null, // C
            'MIERCOLES DD-MM-AAAA': null, // D
            'JUEVES DD-MM-AAAA': null, // F
            'VIERNES DD-MM-AAAA': null, // G
            'SABADO DD-MM-AAAA': null, // H
            'DOMINGO DD-MM-AAAA': null, // I
          },
        ]
  
        const consolidatedWorkSheet = XLSX.utils.json_to_sheet(sheetToExport)
  
        //Cell comment 'CEDULA'
        consolidatedWorkSheet.A1.c = []
        consolidatedWorkSheet.A1.c.hidden = true
        consolidatedWorkSheet.A1.c.push({
          t: 'Por favor solo ingrese números. Mínimo 4 dígitos, máximo 11 dígitos',
        })
  

        //Cell comment 'LUNES'
        consolidatedWorkSheet.B1.c = []
        consolidatedWorkSheet.B1.c.hidden = true
        consolidatedWorkSheet.B1.c.push({
          t: 'Espacio para el horario del lunes, los turnos deben tener hora inicio y fin. Ejm: 05:30-14:30',
        })

        //Cell comment 'MARTES'
        consolidatedWorkSheet.C1.c = []
        consolidatedWorkSheet.C1.c.hidden = true
        consolidatedWorkSheet.C1.c.push({
          t: 'Espacio para el horario del martes, los turnos deben tener hora inicio y fin. Ejm: 05:30-14:30',
        })

        //Cell comment 'MIÉRCOLES'
        consolidatedWorkSheet.D1.c = []
        consolidatedWorkSheet.D1.c.hidden = true
        consolidatedWorkSheet.D1.c.push({
          t: 'Indicar el día de la semana seguido de la fecha correspondiente ej: LUNES DD-MM-AAAA',
          t: 'Espacio para el horario del miércoles, los turnos deben tener hora inicio y fin. Ejm: 05:30-14:30',
        })
        //Cell comment 'MARTES ROW'

        //Cell comment 'JUEVES'
        consolidatedWorkSheet.E1.c = []
        consolidatedWorkSheet.E1.c.hidden = true
        consolidatedWorkSheet.E1.c.push({
          t: 'Espacio para el horario del jueves, los turnos deben tener hora inicio y fin. Ejm: 05:30-14:30',
        })

        //Cell comment 'VIERNES'
        consolidatedWorkSheet.F1.c = []
        consolidatedWorkSheet.F1.c.hidden = true
        consolidatedWorkSheet.F1.c.push({
          t: 'Espacio para el horario del viernes, los turnos deben tener hora inicio y fin. Ejm: 05:30-14:30',
        })

        //Cell comment 'SABADO'
        consolidatedWorkSheet.G1.c = []
        consolidatedWorkSheet.G1.c.hidden = true
        consolidatedWorkSheet.G1.c.push({
          t: 'Espacio para el horario del sábado, los turnos deben tener hora inicio y fin. Ejm: 05:30-14:30',
        })

        //Cell comment 'DOMINGO'
        consolidatedWorkSheet.H1.c = []
        consolidatedWorkSheet.H1.c.hidden = true
        consolidatedWorkSheet.H1.c.push({
          t: 'Espacio para el horario del domingo, los turnos deben tener hora inicio y fin. Ejm: 05:30-14:30',
        })
  
        const workBook = {
          SheetNames: ['data'],
          Sheets: { data: consolidatedWorkSheet },
        }
  
        XLSX.writeFile(workBook, 'Plantilla.xlsx')
      },
      confirmReadFile(){
        const context = this
        context.reading = true
        setTimeout(() => {
          context.readFile()
        }, 500);
      },
      readFile() {
        const context = this
        context.items = []
        const fileReader = new FileReader()
        const readOpts = {
          cellDates: true,
          type: 'binary',
        }
  
        const jsonOpts = {
          raw: false,
          cellNF: true,
        }
  
        fileReader.onload = async (ev) => {
          try {
            context.reading = true
            const data = ev.target.result
            const workbook = XLSX.read(data, readOpts)
  
            const wsname = workbook.SheetNames[0]
            let ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], jsonOpts)
  
            if (ws.length >= 1300) {
              context.reading = false
              return this.$generate_toast(context, 'error', 'Demasiados registros, por favor realice cargas de máximo 1300 filas')
            }
  
            if (ws.length === 0) {
              context.reading = false
              return this.$generate_toast(context, 'error', 'No hay información')
            }
            
            let tmp_items = []
            let startDate, endDate;

            ws.forEach((row, index) => {

              if (index === 0) {
                startDate = context.extractDateFromHeader(row, 'LUNES');
                endDate = context.extractDateFromHeader(row, 'DOMINGO');
              }
              let item = {
                document: row['CEDULA'],
                schedule: {
                  d1: context.getValueByStartsWith(row, 'LUNES'),
                  d2: context.getValueByStartsWith(row, 'MARTES'),
                  d3: context.getValueByStartsWith(row, 'MIERCOLES'),
                  d4: context.getValueByStartsWith(row, 'JUEVES'),
                  d5: context.getValueByStartsWith(row, 'VIERNES'),
                  d6: context.getValueByStartsWith(row, 'SABADO'),
                  d7: context.getValueByStartsWith(row, 'DOMINGO'),
                }
              }
              tmp_items.push(item)
  
            })
            const dateFormatRegex = /^\d{2}-\d{2}-\d{4}$/;
            if (!dateFormatRegex.test(startDate) || !dateFormatRegex.test(endDate) || startDate === endDate) {
              context.reading = false
              return this.$generate_toast(context, 'error', 'El formato de las fechas ingresadas en el encabezado es inválido, por favor valide que sean correctas. EJM: "LUNES 13-11-2023"');
            }
            context.form.date_start = startDate;
            context.form.date_end = endDate;
            context.items = [...tmp_items]
            context.reading = false
          } catch (e) {
            context.reading = false
            return this.$generate_toast(context, 'error', 'Error al leer archivo')
          }
        }
        fileReader.readAsBinaryString(context.file)
        context.reading = false
      },
      extractDateFromHeader(row, day){
        const dateKey = Object.keys(row).find((key) => key.includes(day));
        if (dateKey) {
          const dateString = dateKey.replace(day, '').replace(' ', '').trim();
          return dateString;
        }
        return null;
      },

      getValueByStartsWith(row, start) {
        for (let key in row) {
          if (key.startsWith(start)) {
            return row[key];
          }
        }
        return null; // O el valor por defecto que desees
      },
  
      importExcel(e) {
        const context = this
        const files = e.target.files
        if (!files.length) {
          return
        } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
          return context.$generate_toast(
            context,
            'error',
            'Seleccionar un archivo con formato xls o xlsx'
          )
        }
        context.file = files[0]
        context.selectedFile = true
        // this.readFile(files[0])
      },
  
      submit() {
        let context = this
        context.submitting = true
        const promise = context.manualCreateTimeSoft(context.form)
        return promise
          .then((response) => {
            let data = response.data
            const csvContent = data.csvContent;
            if (response.status !== 206) {
              context.$generate_toast(
                context,
                'success',
                `${context.$t('request_template')} ${
                  context.$t('created')
                } ${context.$t('correctly')}. Los datos están siendo procesados por el sistema, por favor espere mientras se descarga el archivo.`, 'Éxito', 15000
              );
              const url = URL.createObjectURL(
                new Blob([data], {
                    type: 'text/csv',
                })
              )
              let fileName = 'Turnos'
              const link = document.createElement('a')
              link.href = url
              link.setAttribute(
                'download',
                `${fileName}.csv`
              )
              document.body.appendChild(link)
              link.click()
              setTimeout(() => {
                context.oncomplete(data.url || null)
                context.submitting = false
                context.showConfirmModal = false
              }, 15000)
            } else {
              context.$generate_toast(
                context,
                'info',
                `Algunos datos no fueron registrados.`
              )
              context.submitting = false
              context.showConfirmModal = false
            }
          })
          .catch((error) => {
            context.submitting = false
            context.showConfirmModal = false
            context.$axios_error_noty(error, context)
          })
      },
  
      errorMessage(errors=[]) {
        let context = this
        let listFields = errors.map( (error) => context.$t(error)).join(', ')
        let create_message = 'El beneficiario actualmente posee bonos asociados en los rangos de tiempo especificados.'
        let delete_message = 'No se encontró tarjetahabiente con la información especificada.'
  
        if (errors[0] === 'overlapping_coupons' && context.type_action == 'create'){
          return create_message
        } else if( context.type_action == 'delete') {
          delete_message
        }
        return `Los siguientes campos poseen datos inválidos: ${listFields}. `
      },
  
      confirmSubmit() {
        let context = this
        context.$v.form.$touch()
        context.$v.items.$touch()
        if (context.$v.form.$invalid || context.$v.items.$invalid) {
          console.log(context.$v.form.$invalid)
          console.log(context.$v.items.$invalid)
          context.submitting = false
          context.$generate_toast(
            context,
            'error',
            context.$t('fill_the_required_fields')
          )
          return
        }
        context.showConfirmModal = true
      },
    },
  }
  </script>
  
  <template>
    <b-modal
      v-model="modalShow"
      scrollable 
      id='upload-data-modal'
      title="Cargar Plantilla"
      :size="action === 'create' ? 'xl' : 'xl'"
      @hidden="oncancel"
      @ok.prevent="confirmSubmit"
    >
      <div class="p-0">
        <b-row v-if="loading">
          <b-col md="12">
            <div class="text-center">
              <b-spinner
                label="Spinning"
                style="color: #195db2; width: 4rem; height: 4rem"
              ></b-spinner>
            </div>
          </b-col>
        </b-row>
        <b-row v-else class="m-3">
          <b-col md="12">
  
            <div class="mb-3">
              <b-form-group
                class="text-primary font-weight-bold"
                :label="$t('upload_data_from_file')"
              >
                <b-form-file
                  class="border-primary"
                  ref="excel_user_file"
                  :placeholder="$t('select_file')"
                  :drop-placeholder="$t('select_file')"
                  :browse-text="$t('search')"
                  @change="importExcel"
                />
  
              </b-form-group>
              <b-button
                variant="secondary rounded"
                class="mr-2"
                @click="exportExcel"
              >
                <i class="fas fa-file-excel"></i>
                {{ $t('download_template') }}
              </b-button>
              <b-button
                variant="primary rounded"
                :disabled="!selectedFile || submitting || reading"
                @click="confirmReadFile"
              >
                <b-spinner v-if="reading" label="Spinning" small></b-spinner>
                <i v-else class="fas fa-file-import"></i>
                <span> {{ reading ? 'Procesando' : $t('process_file') }} </span>
              </b-button>
            </div>
  
  
          </b-col>
          <b-col class="mt-3">
            <div>
              <!-- <pre>{{ items  }}</pre> -->
              <h5>Vista previa Plantilla </h5>
  
              <div
                v-if="!$v.items.someError && $v.items.minRequired"
                class="alert alert-danger"
                role="alert"
              >
  
  
              {{ type_action === 'create' ? 'Los beneficiarios resaltados actualmente poseen datos inconsistentes': 'Los bonos resaltados no fueron encontrados' }}
                <span class="alert-link">actualice la información y verifique o elimínelos.</span
                >
              </div>
  
              <b-table
                v-if="items.length"
                hover
                small
                :items="items"
                :fields="fields"
                responsive
                :thead-class="['text-primary', 'border-primary']"
                :tbody-tr-class="tbodyRowClass"
              >
                <template #cell(document)="row">
                  <b-form-input
                    size="sm"
                    type="number"
                    v-model="row.item.document"
                    :formatter="(value) => Number(value)"
                    :state="!$v.items.$each[row.index].document.$invalid"
                    v-b-tooltip.focus="{ variant: $v.items.$each[row.index].document.$invalid ? 'danger' : 'success' }"
                    :title="$v.items.$each[row.index].document.$invalid ? 'Obligatorio, debe tener mínimo 4 y máximo 11 dígitos.': 'campo valido'"
                  />
                </template>
                <template #cell(lunes)="row">
                  <b-form-input
                    size="sm"
                    type="text"
                    v-model="row.item.schedule.d1"
                    :state="!$v.items.$each[row.index].schedule.d1.$invalid"
                    v-b-tooltip.focus="{ variant: $v.items.$each[row.index].schedule.d1.$invalid ? 'danger' : 'success' }"
                    :title="$v.items.$each[row.index].schedule.d1.$invalid ? 'Obligatorio, formato de fecha incorrecto.': 'campo valido'"
                  />
                  <p class="text-danger" v-if="$v.items.$each[row.index].schedule.d1.$invalid">Formato de fecha incorrecto.</p>
                </template>
                <template #cell(martes)="row">
                  <b-form-input
                    size="sm"
                    type="text"
                    v-model="row.item.schedule.d2"
                    :state="!$v.items.$each[row.index].schedule.d2.$invalid"
                    v-b-tooltip.focus="{ variant: $v.items.$each[row.index].schedule.d2.$invalid ? 'danger' : 'success' }"
                    :title="$v.items.$each[row.index].schedule.d2.$invalid ? 'Obligatorio, formato de fecha incorrecto.': 'campo valido'"
                  />
                  <p class="text-danger" v-if="$v.items.$each[row.index].schedule.d2.$invalid">Formato de fecha incorrecto.</p>
                </template>
                <template #cell(miercoles)="row">
                  <b-form-input
                    size="sm"
                    type="text"
                    v-model="row.item.schedule.d3"
                    :state="!$v.items.$each[row.index].schedule.d3.$invalid"
                    v-b-tooltip.focus="{ variant: $v.items.$each[row.index].schedule.d3.$invalid ? 'danger' : 'success' }"
                    :title="$v.items.$each[row.index].schedule.d3.$invalid ? 'Obligatorio, formato de fecha incorrecto.': 'campo valido'"
                  />
                  <p class="text-danger" v-if="$v.items.$each[row.index].schedule.d3.$invalid">Formato de fecha incorrecto.</p>
                </template>
                <template #cell(jueves)="row">
                  <b-form-input
                    size="sm"
                    type="text"
                    v-model="row.item.schedule.d4"
                    :state="!$v.items.$each[row.index].schedule.d4.$invalid"
                    v-b-tooltip.focus="{ variant: $v.items.$each[row.index].schedule.d4.$invalid ? 'danger' : 'success' }"
                    :title="$v.items.$each[row.index].schedule.d4.$invalid ? 'Obligatorio, formato de fecha incorrecto.': 'campo valido'"
                  />
                  <p class="text-danger" v-if="$v.items.$each[row.index].schedule.d4.$invalid">Formato de fecha incorrecto.</p>
                </template>
                <template #cell(viernes)="row">
                  <b-form-input
                    size="sm"
                    type="text"
                    v-model="row.item.schedule.d5"
                    :state="!$v.items.$each[row.index].schedule.d5.$invalid"
                    v-b-tooltip.focus="{ variant: $v.items.$each[row.index].schedule.d5.$invalid ? 'danger' : 'success' }"
                    :title="$v.items.$each[row.index].schedule.d5.$invalid ? 'Obligatorio, formato de fecha incorrecto.': 'campo valido'"
                  />
                  <p class="text-danger" v-if="$v.items.$each[row.index].schedule.d5.$invalid">Formato de fecha incorrecto.</p>
                </template>
                <template #cell(sabado)="row">
                  <b-form-input
                    size="sm"
                    type="text"
                    v-model="row.item.schedule.d6"
                    :state="!$v.items.$each[row.index].schedule.d6.$invalid"
                    v-b-tooltip.focus="{ variant: $v.items.$each[row.index].schedule.d6.$invalid ? 'danger' : 'success' }"
                    :title="$v.items.$each[row.index].schedule.d6.$invalid ? 'Obligatorio, formato de fecha incorrecto.': 'campo valido'"
                  />
                  <p class="text-danger" v-if="$v.items.$each[row.index].schedule.d6.$invalid">Formato de fecha incorrecto.</p>
                </template>
                <template #cell(domingo)="row">
                  <b-form-input
                    size="sm"
                    type="text"
                    v-model="row.item.schedule.d7"
                    :state="!$v.items.$each[row.index].schedule.d7.$invalid"
                    v-b-tooltip.focus="{ variant: $v.items.$each[row.index].schedule.d7.$invalid ? 'danger' : 'success' }"
                    :title="$v.items.$each[row.index].schedule.d7.$invalid ? 'Obligatorio, formato de fecha incorrecto.': 'campo valido'"
                  />
                  <p class="text-danger" v-if="$v.items.$each[row.index].schedule.d7.$invalid">Formato de fecha incorrecto.</p>
                </template>
                <template #cell(actions)="row">
                  <div style="min-width: 75px">
                    <b-button
                      :id="`delete-btn-${row.index}`"
                      v-b-tooltip.hover="{
                        variant: 'primary',
                        placement: 'leftbottom',
                        title: $t('delete'),
                      }"
                      variant="btn-link text-primary btn-transparent"
                      @click="
                        () => {
                          removeItem(row.index)
                        }
                      "
                    >
                      <i class="far fa-trash-alt"></i>
                    </b-button>
                    <b-button
                    v-if="row.item.errors && row.item.error"
                      :id="`info-btn-${row.index}`"
                      v-b-tooltip.hover="{
                        variant: 'danger',
                        placement: 'leftbottom',
                        title: errorMessage(row.item.errors),
                      }"
                      variant="btn-link text-danger btn-transparent mx-1"
                    >
                    <i class="fas fa-exclamation-circle"></i>
                    </b-button>
                    <b-button
                      v-if="row.item.error"
                      :id="`check-btn-${row.index}`"
                      v-b-tooltip.hover="{
                        variant: 'success',
                        placement: 'top',
                        title: 'De clic para indicar que el registro fue corregido.',
                      }"
                      variant="btn-link text-success btn-transparent"
                      @click="
                        () => {
                          toggleError(row.index)
                        }
                      "
                    >
                      <i class="far fa-calendar-check"></i>
                    </b-button>
                  </div>
                </template>
                <template #custom-foot>
                  <b-tr>
                    <b-td
                      colspan="3"
                      class="text-primary font-weight-bold text-right"
                      style="border-top: solid 1px"
                      ><span>Total</span></b-td
                    >
                    <b-td
                      class="border-primary text-center"
                      style="border-top: solid 1px"
                      >{{ $formatDollar(quantity) }}</b-td
                    >
                  </b-tr>
                </template>
              </b-table>
            </div>
            <div
              v-if="!$v.items.minRequired"
              class="alert alert-danger"
              role="alert"
            >
              La solicitud debe tener
              <span class="alert-link"> al menos un registro y máximo 1300</span>.
            </div>
          </b-col>
        </b-row>
      </div>
  
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="outline-primary" class="rounded-lg" @click="cancel">
          Cancelar
        </b-button>
  
        <b-button
          :variant=" type_action === 'create' ? 'primary' : 'danger'"
          class="rounded-lg"
          :disabled="!$v.items.minRequired"
          :class="{ disabled: submitting }"
          @click="ok"
        >
          <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
          <span v-if="submitting"> {{ type_action === 'create' ? $t('saving') : $t('deleting') }} </span>
          <span v-else>
            <i :class="{'fe-save': type_action === 'create',
            'far fa-trash-alt': type_action === 'delete'}"></i>
            {{ type_action === 'create' ? $t('create') : $t('delete') }}
          </span>
        </b-button>
      </template>
      <ConfirmModal
        v-if="showConfirmModal"
        :close-modal="
          () => {
            showConfirmModal = false
          }
        "
        :on-submit="submit"
        :submitting="submitting"
        :warningMessage="`¿Esta seguro de ${ type_action === 'create' ? $t('create') : $t('delete') } los registros con la información indicada?`"
      />
    </b-modal>
  </template>
  <style lang="scss">
  
  #upload-data-modal .modal-dialog {
      max-width: 95%;
      height: 95vh;
      display: flex;
  }
  </style>